import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../style/pdp.css";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";

const extractSrcFromIframe = (iframeString) => {
  const match = iframeString.match(/src=([^\s]+)/);
  return match ? match[1] : "";
};

const VideoVirtualTour = ({ videoData }) => {
  const PrevArrow = ({ onClick }) => (
    <button className="custom-arrow-carousal prev" onClick={onClick}>
      <IoIosArrowBack size={80} style={{ color: "white" }} />
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button className="custom-arrow-carousal next" onClick={onClick}>
      <IoIosArrowForward size={80} style={{ color: "white" }} />
    </button>
  );

  // const settings = {
  //     dots: false,
  //     infinite: true,
  //     speed: 500,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     autoplay: false,
  //     arrows: true,
  //     prevArrow: <PrevArrow />,
  //     nextArrow: <NextArrow />,
  // };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <div className="video-carousel-container">
      <Slider {...settings}>
        {videoData.map((video, index) => {
          const src = extractSrcFromIframe(video.virtualTourUrl);
          return (
            <div key={index} className="video-slide">
              <div className="video-wrapper">
                <iframe
                  src={src}
                  title={`Virtual Tour ${video.videoDisplaySequence}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <div className="video-number-bottom-right">
                  {`${index + 1} / ${videoData.length}`}
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default VideoVirtualTour;
